// extracted by mini-css-extract-plugin
module.exports = {"object_info":"index_object_info__3SITm","object_info__content":"index_object_info__content__2Tj_d","object_info__close_icon":"index_object_info__close_icon__2ErqL"};